var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoctorDash02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0005 3.60156C14.9657 3.60156 11.6855 6.88176 11.6855 10.9166C11.6855 14.8744 14.7809 18.0776 18.8157 18.2162C18.9389 18.2008 19.0621 18.2008 19.1545 18.2162C19.1853 18.2162 19.2007 18.2162 19.2315 18.2162C19.2469 18.2162 19.2469 18.2162 19.2623 18.2162C23.2047 18.0776 26.3001 14.8744 26.3155 10.9166C26.3155 6.88176 23.0353 3.60156 19.0005 3.60156Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M26.823 22.3124C22.5264 19.448 15.5194 19.448 11.192 22.3124C9.2362 23.6214 8.1582 25.3924 8.1582 27.2866C8.1582 29.1808 9.2362 30.9364 11.1766 32.23C13.3326 33.6776 16.1662 34.4014 18.9998 34.4014C21.8334 34.4014 24.667 33.6776 26.823 32.23C28.7634 30.921 29.8414 29.1654 29.8414 27.2558C29.826 25.3616 28.7634 23.606 26.823 22.3124Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0796 26.1347H20.1546V24.2097C20.1546 23.5783 19.631 23.0547 18.9996 23.0547C18.3682 23.0547 17.8446 23.5783 17.8446 24.2097V26.1347H15.9196C15.2882 26.1347 14.7646 26.6583 14.7646 27.2897C14.7646 27.9211 15.2882 28.4447 15.9196 28.4447H17.8446V30.3697C17.8446 31.0011 18.3682 31.5247 18.9996 31.5247C19.631 31.5247 20.1546 31.0011 20.1546 30.3697V28.4447H22.0796C22.711 28.4447 23.2346 27.9211 23.2346 27.2897C23.2346 26.6583 22.711 26.1347 22.0796 26.1347Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorDash02);
export default __webpack_public_path__ + "static/media/doctor-dash-02.9e66333b53c0a2efc08b99b459700a7b.svg";
export { ForwardRef as ReactComponent };